/* Weslora product page — gallery, lightbox, add to cart (theme cart drawer), sticky bar.
   No dependencies. Purchase always falls back to Shopify's normal /cart/add form post. */
(function () {
  'use strict';
  if (window.wslProductLoaded) return;
  window.wslProductLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------- Gallery ---------------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-wsl-pdp-gallery]').forEach(function (gallery) {
      if (gallery.dataset.wslReady) return;
      gallery.dataset.wslReady = '1';
      var track = gallery.querySelector('[data-wsl-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-wsl-slide-index]');
      var thumbs = gallery.querySelectorAll('[data-wsl-goto]');
      var counter = gallery.querySelector('[data-wsl-current]');
      var zooms = gallery.querySelectorAll('[data-wsl-zoom]');
      var current = 0;

      function setActive(i) {
        current = i;
        zooms.forEach(function (z, n) { z.tabIndex = n === i ? 0 : -1; });
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var active = thumbs[i];
        if (active && active.parentElement) {
          var box = active.parentElement;
          if (box.scrollHeight > box.clientHeight + 2) box.scrollTo({ top: active.offsetTop - box.clientHeight / 2 + active.offsetHeight / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
          else if (box.scrollWidth > box.clientWidth + 2) box.scrollTo({ left: active.offsetLeft - box.clientWidth / 2 + active.offsetWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        if (counter) counter.textContent = String(i + 1);
      }
      function goTo(i, smooth) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
        setActive(i);
      }
      gallery.wslGoTo = goTo;

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-wsl-goto'), 10), true); });
      });
      var prev = gallery.querySelector('[data-wsl-prev]');
      var next = gallery.querySelector('[data-wsl-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(current + 1, true); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var step = slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft) : track.clientWidth;
          var i = Math.round(track.scrollLeft / Math.max(1, step));
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) i = slides.length - 1;
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        });
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        goTo(current + (e.key === 'ArrowRight' ? 1 : -1), true);
        if (zooms[current]) zooms[current].focus({ preventScroll: true });
      });

      gallery.querySelectorAll('[data-wsl-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () { openLightbox(parseInt(btn.getAttribute('data-wsl-zoom'), 10), btn); });
      });
    });
  }

  /* ---------------- Lightbox ---------------- */
  var lb = null;
  function lightboxState() {
    if (lb) return lb;
    var dialog = document.querySelector('[data-wsl-lightbox]');
    if (!dialog) return null;
    var data = [];
    try { data = JSON.parse(dialog.querySelector('[data-wsl-lightbox-data]').textContent); } catch (e) { data = []; }
    lb = {
      dialog: dialog,
      img: dialog.querySelector('[data-wsl-lightbox-img]'),
      count: dialog.querySelector('[data-wsl-lightbox-current]'),
      data: data,
      index: 0,
      opener: null
    };
    function show(i) {
      if (!lb.data.length) return;
      lb.index = (i + lb.data.length) % lb.data.length;
      var item = lb.data[lb.index];
      lb.img.classList.remove('is-loaded');
      lb.img.onload = function () { lb.img.classList.add('is-loaded'); };
      lb.img.src = item.src;
      lb.img.alt = item.alt || '';
      if (lb.count) lb.count.textContent = String(lb.index + 1);
    }
    lb.show = show;
    var prev = dialog.querySelector('[data-wsl-lightbox-prev]');
    var next = dialog.querySelector('[data-wsl-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { show(lb.index - 1); });
    if (next) next.addEventListener('click', function () { show(lb.index + 1); });
    dialog.querySelector('[data-wsl-lightbox-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(lb.index + 1);
      if (e.key === 'ArrowLeft') show(lb.index - 1);
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('wsl-lock');
      var gallery = document.querySelector('[data-wsl-pdp-gallery]');
      if (gallery && gallery.wslGoTo && lb.opener && lb.opener.hasAttribute('data-wsl-zoom')) gallery.wslGoTo(lb.index, false);
      if (lb.opener && document.contains(lb.opener)) lb.opener.focus();
    });
    return lb;
  }
  function openLightbox(i, opener) {
    var state = lightboxState();
    if (!state || typeof state.dialog.showModal !== 'function') return;
    state.opener = opener || null;
    state.show(i);
    document.documentElement.classList.add('wsl-lock');
    state.dialog.showModal();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-wsl-open-lightbox]');
    if (t) openLightbox(parseInt(t.getAttribute('data-wsl-open-lightbox'), 10), t);
  });

  /* ---------------- Variant select (only when the product has variants) ---------------- */
  function initVariants(scope) {
    (scope || document).querySelectorAll('[data-wsl-variant-select]').forEach(function (select) {
      if (select.dataset.wslReady) return;
      select.dataset.wslReady = '1';
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var amount = document.querySelector('[data-wsl-price-amount]');
        var sticky = document.querySelector('[data-wsl-sticky-price]');
        if (amount) amount.textContent = opt.getAttribute('data-price');
        if (sticky) sticky.textContent = opt.getAttribute('data-price');
        var compare = document.querySelector('[data-wsl-compare]');
        if (compare) compare.hidden = !opt.getAttribute('data-compare');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------------- Add to cart ---------------- */
  function cartTarget() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') return drawer;
    var note = document.querySelector('cart-notification');
    if (note && typeof note.renderContents === 'function' && typeof note.getSectionsToRender === 'function') return note;
    return null;
  }

  function setBusy(form, busy) {
    form.querySelectorAll('[data-wsl-add]').forEach(function (b) {
      b.classList.toggle('is-loading', busy);
      b.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (busy) b.setAttribute('disabled', 'disabled');
      else if (!b.dataset.wslSoldOut) b.removeAttribute('disabled');
    });
    var sticky = form.id ? document.querySelector('[data-wsl-sticky-btn][form="' + form.id + '"]') : null;
    if (sticky) sticky.classList.toggle('is-loading', busy);
  }

  function setStatus(form, message, isError) {
    var status = form.querySelector('[data-wsl-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!isError);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-wsl-buy-form]')) return;
    if (!window.fetch || !window.FormData) return; // native POST fallback
    e.preventDefault();

    var target = cartTarget();
    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');
    if (target) {
      var ids = target.getSectionsToRender().map(function (s) { return s.section || s.id; });
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof target.setActiveElement === 'function') target.setActiveElement(document.activeElement);
    }

    setBusy(form, true);
    setStatus(form, 'Adding to your cart…', false);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          var msg = (result.json && (result.json.description || result.json.message)) || 'Sorry, something went wrong. Please try again.';
          setStatus(form, msg, true);
          return;
        }
        setStatus(form, 'Added to your cart.', false);
        document.dispatchEvent(new CustomEvent('wsl:cart:added', { detail: result.json }));
        if (target) {
          try {
            target.renderContents(result.json);
            if (target.classList && !target.classList.contains('active') && typeof target.open === 'function') {
              setTimeout(function () { if (!target.classList.contains('active')) target.open(); }, 250);
            }
          } catch (err) {
            window.location.href = root + 'cart';
          }
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        setStatus(form, 'We couldn’t reach the cart. Redirecting…', true);
        form.dataset.wslNative = '1';
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () { setBusy(form, false); });
  }
  document.addEventListener('submit', onSubmit);

  function markSoldOut(scope) {
    (scope || document).querySelectorAll('[data-wsl-add][disabled]').forEach(function (b) { b.dataset.wslSoldOut = '1'; });
  }

  /* ---------------- Sticky purchase bar ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-wsl-sticky]');
    var anchor = document.querySelector('[data-wsl-main-actions]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var finalCta = document.querySelector('[data-wsl-buycta]');
    var footer = document.querySelector('.wsl-footer');
    var mainVisible = true;
    var endVisible = false;
    var btn = bar.querySelector('[data-wsl-sticky-btn]');

    function update() {
      var above = anchor.getBoundingClientRect().bottom < 0;
      var show = !mainVisible && above && !endVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('wsl-has-sticky', show);
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(anchor);
    var endObs = new IntersectionObserver(function (entries) {
      endVisible = entries.some(function (en) { return en.isIntersecting; });
      update();
    });
    if (finalCta) endObs.observe(finalCta);
    if (footer) endObs.observe(footer);
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; update(); });
    }, { passive: true });
  }

  function init(scope) {
    initGallery(scope);
    initVariants(scope);
    markSoldOut(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initSticky(); });
  } else {
    init();
    initSticky();
  }
  document.addEventListener('shopify:section:load', function (e) { lb = null; init(e.target); });
})();
